<template>
  <v-container  class="text-center ma-4 blue--text">
    <h1>Loading...
      <v-progress-circular
        indeterminate="indeterminate"
      ></v-progress-circular>
    </h1>
    <br />
    <h2 v-if="show1">
      Well this is taking a while... sometimes the first load is slow.
      Give it a few seconds more!
      It should be faster after this.
    </h2>
  </v-container>
</template>

<script>
export default {
  name: 'Loading',

  data: () => ({
    show1: false

  }),
  mounted () {
    window.setTimeout(() => {
      this.show1 = true
    }, 3000)
  }
}
</script>
